import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

// .py / .sh open in the script runner: a Src ↔ Run two-mode editor.
// Src reuses the collaborative text surface; Run executes the script in
// the same sandbox the agent uses (see
// docs/plans/2026-05-15_STANDALONE_SCRIPT_RUNNER.md).
const LazyScriptEditor = lazy(() =>
  import('../../ui/ScriptEditor.js').then(m => ({ default: m.ScriptEditor }))
)

registerEditor({
  notifiesFileGone: true, // #823: FileStateBanner, from the room's close
  family: 'script',
  extensions: ['py', 'sh'],
  name: 'Script Runner',
  component: LazyScriptEditor,
  maxEditableSize: 1024 * 1024, // 1 MB — same guard as the text editor
})
